export default {
  routeTitle: 'Alterar Domínio',
  subtitle: 'Site: {domain}',
  label: 'Novo Domínio',
  hint: 'Escolha um novo domínio válido',
  placeholder: 'Digite seu domínio aqui',
  explanation: 'Se o seu domínio foi registrado fora da Locaweb, será preciso alterar os endereços de DNS para concluir esta operação.',
  button: 'Alterar domínio'
}
